import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 0,
  class: "preco_de"
}
const _hoisted_3 = { class: "preco" }
const _hoisted_4 = { class: "centavos" }
const _hoisted_5 = {
  key: 0,
  class: "preco_de"
}
const _hoisted_6 = { class: "preco" }
const _hoisted_7 = { class: "centavos" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Você conseguiu!")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Você conseguiu Frete Grátis!")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProdutoModal = _resolveComponent("ProdutoModal")!
  const _component_ion_skeleton_text = _resolveComponent("ion-skeleton-text")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_input = _resolveComponent("ion-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ProdutoModal, {
      onOnDismiss: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal=false)),
      produto: _ctx.produto,
      show: _ctx.showModal
    }, null, 8, ["produto", "show"]),
    (_ctx.produto.name=='')
      ? (_openBlock(), _createBlock(_component_ion_row, {
          key: 0,
          class: "ion-align-items-center categoria-item"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_col, { size: "12" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_thumbnail, { class: "ion-text-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_skeleton_text, { animated: true })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_col, { size: "12" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_skeleton_text, {
                  animated: true,
                  style: {"width":"80%"}
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_col, { size: "12" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_skeleton_text, {
                  animated: true,
                  style: {"height":"30px"}
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.produto.name!='')
      ? (_openBlock(), _createBlock(_component_ion_row, {
          key: 1,
          class: "ion-align-items-center produto",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showProduto()))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_col, {
              class: "ion-text-center produto-imagem-col",
              size: "12"
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  class: "produto-imagem",
                  src: _ctx.produto.image+'?sw=100&sfrm=png&sm=fit&q=30'
                }, null, 8, _hoisted_1)
              ]),
              _: 1
            }),
            _createVNode(_component_ion_col, {
              class: "descricao",
              size: "12"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.produto.name), 1)
              ]),
              _: 1
            }),
            (_ctx.produto.incart == true && _ctx.produto.loading)
              ? (_openBlock(), _createBlock(_component_ion_col, {
                  key: 0,
                  class: "preco-qtd",
                  size: "7"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_spinner)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.produto.incart == true && !_ctx.produto.loading && !_ctx.produto.not_avaliable)
              ? (_openBlock(), _createBlock(_component_ion_col, {
                  key: 1,
                  size: "7"
                }, {
                  default: _withCtx(() => [
                    (_ctx.produto.price_from && _ctx.produto.price_from != _ctx.produto.price)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$cart.currencyUSD(_ctx.produto.price_from)), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_3, [
                      _createTextVNode(_toDisplayString(_ctx.$cart.currencyUP(_ctx.produto.price)[0]) + ",", 1),
                      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$cart.currencyUP(_ctx.produto.price)[1]), 1)
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.produto.name!='')
      ? (_openBlock(), _createBlock(_component_ion_row, { key: 2 }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_row, null, {
              default: _withCtx(() => [
                (_ctx.produto.incart != true && !_ctx.produto.not_avaliable)
                  ? (_openBlock(), _createBlock(_component_ion_col, {
                      key: 0,
                      size: "9",
                      class: "ion-text-end"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.produto.price_from)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$cart.currencyUSD(_ctx.produto.price_from)), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_6, [
                          _createTextVNode(_toDisplayString(_ctx.$cart.currencyUP(_ctx.produto.price)[0]) + ",", 1),
                          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$cart.currencyUP(_ctx.produto.price)[1]), 1)
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.produto.incart != true && !_ctx.produto.not_avaliable)
                  ? (_openBlock(), _createBlock(_component_ion_col, {
                      key: 1,
                      size: "3",
                      class: "ion-text-end font-25 bottoes_acao_add",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$cart.doAddCartMain(_ctx.produto)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          color: "jauservelayout",
                          icon: _ctx.addCircleOutline,
                          size: "large"
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (_ctx.produto.not_avaliable)
              ? (_openBlock(), _createBlock(_component_ion_col, {
                  key: 0,
                  size: "12",
                  class: "not_avaliable"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.produto.error || 'Este produto não está mais disponível no momento'), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.produto.incart && !_ctx.produto.not_avaliable)
              ? (_openBlock(), _createBlock(_component_ion_col, {
                  key: 1,
                  size: "12"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_row, { class: "ion-align-items-center ion-no-padding" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, {
                          size: "4",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$cart.doAddMainMinus(_ctx.produto))),
                          class: "ion-text-end ion-no-padding"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, {
                              class: "ion_icon",
                              color: "jauservelayout",
                              icon: _ctx.removeCircleOutline
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_col, {
                          size: "4",
                          class: "ion-text-center ion-no-padding"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_input, {
                              type: "number",
                              class: "item_qtd_produto",
                              modelValue: _ctx.produto.qtd,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.produto.qtd) = $event)),
                              onIonInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.produto.changed=true)),
                              onKeyup: _cache[6] || (_cache[6] = _withKeys(($event: any) => (_ctx.$cart.doSetCartQtd(_ctx.produto, _ctx.produto.qtd)), ["enter"])),
                              onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.produto.qtd=$event.target.value)),
                              placeholder: "QTD"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_col, {
                          size: "4",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => {_ctx.$cart.doAddMainPlus(_ctx.produto);_ctx.produto.changed=false}),
                          class: "ion-text-start ion-no-padding"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, {
                              class: "ion_icon",
                              color: "jauservelayout",
                              icon: _ctx.produto.changed?_ctx.checkmark:_ctx.addCircleOutline
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!!_ctx.produto.prices_info.priceKg)
              ? (_openBlock(), _createBlock(_component_ion_col, {
                  key: 2,
                  size: "12",
                  class: "unidade_kg"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_row, null, {
                      default: _withCtx(() => [
                        _createTextVNode(" Preço por kg: R$" + _toDisplayString(_ctx.produto.prices_info.priceKg), 1),
                        _hoisted_8,
                        _createTextVNode(" Aprox. " + _toDisplayString(_ctx.produto.prices_info.totalUnidade + "" + _ctx.produto.prices_info.unit) + " por unidade ", 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!!_ctx.produto.prices_info.maxQuantityByCpf)
              ? (_openBlock(), _createBlock(_component_ion_col, {
                  key: 3,
                  size: "12",
                  class: "unidade_kg"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_row, null, {
                      default: _withCtx(() => [
                        _createTextVNode(" *Limitado a " + _toDisplayString(_ctx.produto.prices_info.maxQuantityByCpf) + " unidades ", 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_ion_col, { size: "12" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produto.c_productPromotions, (promocoes, index) => {
                  return (_openBlock(), _createBlock(_component_ion_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        class: "promo_msg",
                        size: "12",
                        innerHTML: promocoes.msg
                      }, null, 8, ["innerHTML"]),
                      _createVNode(_component_ion_col, {
                        class: "promo_detail",
                        size: "12",
                        innerHTML: promocoes.details
                      }, null, 8, ["innerHTML"]),
                      (!promocoes.t && promocoes.shortText)
                        ? (_openBlock(), _createBlock(_component_ion_col, {
                            key: 0,
                            class: "promo_short",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(promocoes.shortText), 1)
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024))
                }), 256))
              ]),
              _: 1
            }),
            _createVNode(_component_ion_col, { size: "12" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itens(_ctx.produto.id).price_adjustments, (promocoes, index) => {
                  return (_openBlock(), _createBlock(_component_ion_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        class: "promo_detail_apli",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                }), 256)),
                (_ctx.itens(_ctx.produto.id).frete_gratis)
                  ? (_openBlock(), _createBlock(_component_ion_row, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, {
                          class: "promo_detail_apli ion-text-center",
                          size: "12"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_10
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}